export default "__VITE_ASSET__Dy2N3hsD__"